import React from "react";
import NavBar from "../NavBar";

const Header = () => {
  return (
    <>
      <NavBar />
    </>
  );
};

export default Header;
